import { ArrowUpRight } from "lucide-react";
import { TEST_IDS, PLATFORM_LINKS } from "@/constants/testIds";

const Hero = () => {
    return (
        <section
            id="top"
            data-testid={TEST_IDS.heroSection}
            className="relative isolate overflow-hidden pt-32 md:pt-40 pb-20 md:pb-28"
        >
            {/* Subtle geometric pattern layers */}
            <div className="absolute inset-0 hero-pattern opacity-70 pointer-events-none" aria-hidden="true" />
            <div className="absolute inset-0 hero-lines opacity-60 pointer-events-none" aria-hidden="true" />

            {/* Soft radial highlight */}
            <div
                className="absolute -top-32 left-1/2 -translate-x-1/2 w-[900px] h-[900px] rounded-full pointer-events-none"
                style={{
                    background:
                        "radial-gradient(ellipse at center, rgba(25,54,117,0.06) 0%, rgba(25,54,117,0) 60%)",
                }}
                aria-hidden="true"
            />

            <div className="relative max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
                <div className="max-w-4xl">
                    <p className="text-[11px] md:text-xs tracking-[0.3em] uppercase text-navy font-medium mb-6">
                        Southern African Traders Ltd · United Kingdom
                    </p>

                    <h1
                        data-testid={TEST_IDS.heroHeadline}
                        className="font-serif text-[44px] sm:text-5xl md:text-6xl lg:text-[76px] leading-[1.05] tracking-tight text-ink"
                    >
                        Building digital platforms <br className="hidden md:block" />
                        that bring people{" "}
                        <span className="italic font-medium text-navy">together.</span>
                    </h1>

                    <p className="mt-8 max-w-2xl text-base md:text-lg leading-relaxed text-muted2">
                        Southern African Traders Ltd develops and supports digital platforms
                        centred on dialogue, education, cultural exchange, and integration —
                        with a focus on emerging markets.
                    </p>

                    <div className="mt-10 flex flex-col sm:flex-row gap-4">
                        <a
                            href={PLATFORM_LINKS.linguisticQuest}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid={TEST_IDS.heroExploreLq}
                            className="group inline-flex items-center justify-center gap-3 bg-navy text-white px-7 py-4 text-[12px] tracking-[0.18em] uppercase font-medium hover:bg-navy-900 transition-colors duration-300"
                        >
                            Explore Linguistic Quest
                            <ArrowUpRight
                                size={16}
                                strokeWidth={1.5}
                                className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
                            />
                        </a>
                        <a
                            href={PLATFORM_LINKS.playTsoro}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid={TEST_IDS.heroExploreTsoro}
                            className="group inline-flex items-center justify-center gap-3 bg-transparent text-ink border border-ink px-7 py-4 text-[12px] tracking-[0.18em] uppercase font-medium hover:bg-ink hover:text-white transition-colors duration-300"
                        >
                            Explore Play Tsoro
                            <ArrowUpRight
                                size={16}
                                strokeWidth={1.5}
                                className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
                            />
                        </a>
                    </div>
                </div>

                {/* Decorative emblem strip */}
                <div className="mt-20 md:mt-28 flex items-center gap-6 text-muted2">
                    <div className="hairline flex-1" />
                    <span className="text-[10px] tracking-[0.32em] uppercase">
                        Dialogue · Education · Culture · Integration
                    </span>
                    <div className="hairline flex-1" />
                </div>
            </div>
        </section>
    );
};

export default Hero;
